<div id="section-typography" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Typography</p>

    <div class="row m-t-20">
      <div class="col-12">
        <p class="h3 m-b-20">Variants</p>
      </div>

      <div class="col-xs-12 col-md-6">
        <div class="copy-container">
          <p #h1Class class="h1 m-t-12">class .h1</p>
          <copy-element [html]="h1Class"></copy-element>
        </div>

        <div class="copy-container">
          <p #h2Class class="h2 m-t-12">class .h2</p>
          <copy-element [html]="h2Class"></copy-element>
        </div>

        <div class="copy-container">
          <p #h3Class class="h3 m-t-12">class .h3</p>
          <copy-element [html]="h3Class"></copy-element>
        </div>

        <div class="copy-container">
          <p #h4Class class="h4 m-t-12">class .h4</p>
          <copy-element [html]="h4Class"></copy-element>
        </div>

        <div class="copy-container">
          <p #h5Class class="h5 m-t-12">class .h5</p>
          <copy-element [html]="h5Class"></copy-element>
        </div>

        <div class="copy-container">
          <p #h6Class class="h6 m-t-12">class .h6</p>
          <copy-element [html]="h6Class"></copy-element>
        </div>

        <div class="copy-container">
          <p #h7Class class="h7 m-t-12">class .h7</p>
          <copy-element [html]="h7Class"></copy-element>
        </div>

        <div class="copy-container">
          <p #h8Class class="h8 m-t-12">class .h8</p>
          <copy-element [html]="h8Class"></copy-element>
        </div>
      </div>

      <div class="col-xs-12 col-md-6">
        <div class="copy-container">
          <h1 #h1Element class="m-t-12">Element - h1</h1>
          <copy-element [html]="h1Element"></copy-element>
        </div>

        <div class="copy-container">
          <h2 #h2Element class="m-t-12">Element - h2</h2>
          <copy-element [html]="h2Element"></copy-element>
        </div>

        <div class="copy-container">
          <h3 #h3Element class="m-t-12">Element - h3</h3>
          <copy-element [html]="h3Element"></copy-element>
        </div>

        <div class="copy-container">
          <h4 #h4Element class="m-t-12">Element - h4</h4>
          <copy-element [html]="h4Element"></copy-element>
        </div>

        <div class="copy-container">
          <h5 #h5Element class="m-t-12">Element - h5</h5>
          <copy-element [html]="h5Element"></copy-element>
        </div>

        <div class="copy-container">
          <h6 #h6Element class="m-t-12">Element - h6</h6>
          <copy-element [html]="h6Element"></copy-element>
        </div>
      </div>
    </div>

    <div class="row m-t-20">
      <div class="col-12">
        <p class="h3 m-b-20">Color</p>
      </div>

      <div class="col-12 col-md-4 m-t-12"><p class="text-common">.text-common</p></div>
      <div class="col-12 col-md-4 m-t-12"><p class="text-primary">.text-primary</p></div>
      <div class="col-12 col-md-4 m-t-12"><p class="text-secondary">.text-secondary</p></div>
      <div class="col-12 col-md-4 m-t-12"><p class="text-secondary-1">.text-secondary-1</p></div>
      <div class="col-12 col-md-4 m-t-12"><p class="text-secondary-2">.text-secondary-2</p></div>
      <div class="col-12 col-md-4 m-t-12"><p class="text-accent-1">.text-accent-1</p></div>
      <div class="col-12 col-md-4 m-t-12"><p class="text-accent-2">.text-accent-2</p></div>
      <div class="col-12 col-md-4 m-t-12"><p class="text-success">.text-success</p></div>
      <div class="col-12 col-md-4 m-t-12"><p class="text-danger">.text-danger</p></div>
      <div class="col-12 col-md-4 m-t-12"><p class="text-warning">.text-warning</p></div>
      <div class="col-12 col-md-4 m-t-12"><p class="text-info">.text-info</p></div>
    </div>

    <div class="row m-t-20">
      <div class="col-12">
        <p class="h3 m-b-20">Weight</p>
      </div>

      <div class="col-12 m-t-12"><p class="ff-light">Font-Light - .ff-light</p></div>
      <div class="col-12 m-t-12"><p class="ff-regular">Font-Regular - .ff-regular</p></div>
      <div class="col-12 m-t-12"><p class="ff-medium">Font-Medium - .ff-medium</p></div>
      <div class="col-12 m-t-12"><p class="ff-bold">Font-Bold - .ff-bold</p></div>
    </div>

    <div class="row m-t-20">
      <div class="col-12">
        <p class="h3 m-b-20">Icons</p>
      </div>

      <div class="col-3 col-md-3 m-t-12"><span class="material-symbols-outlined"> search </span></div>
      <div class="col-3 col-md-3 m-t-12"><span class="material-symbols-outlined"> home </span></div>
      <div class="col-3 col-md-3 m-t-12"><span class="material-symbols-outlined"> menu </span></div>
      <div class="col-3 col-md-3 m-t-12"><span class="material-symbols-outlined"> close </span></div>

      <div class="col-12">
        These are some examples of icons and how to use them, you can find more at:
        <a
          href="https://fonts.google.com/icons?hl=pt-br&selected=Material+Symbols+Outlined:search:FILL@0;wght@400;GRAD@0;opsz@24&icon.size=24&icon.color=%235f6368"
          rel="noopener noreferrer"
          target="_blank"
          >Google Fonts</a
        >.
      </div>
    </div>
  </div>
</div>
